import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postPriceAdjustment = (
    token: string,
    backend: string,
    ChangedByID: string,
    CreatedByID: string,
    Name: string,
    Discount: string,
) => {
    return fetch(
        `${getApiUrl(backend)}price_lists`,
        {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                ChangedByID,
                CreatedByID,
                Name,
                Discount,
            })
        }
    );
};

export default postPriceAdjustment;
